export default {
  setOurteamUIState: (state, value) => state.ourteamUIState = value,
}